(function() {
  angular
    .module("ticketco/ticketbuyer/gift_cards")
    .controller(
      "checkGiftCardBalanceDialogController",
      checkBalanceDialogControllerFactory("gift_cards")
    )
    .controller(
      "checkClickCardBalanceDialogController",
      checkBalanceDialogControllerFactory("click_cards")
    )
    .controller(
      "checkVoucherBalanceDialogController",
      checkBalanceDialogControllerFactory("vouchers")
    );

  function checkBalanceDialogControllerFactory(type) {
    return [
      "BalanceItemsPersistence",
      function(BalanceItemsPersistence) {
        var self = this;
        self.loading = false;

        self.checkCommand = function(model) {
          self.loading = true;

          model.type = type;

          return BalanceItemsPersistence.checkBalance(model)
            .then(function(res) {
              self.result = res;
              //self.closeThisDialog();
              return res;
            })
            .catch(function(err) {
              self.loading = false;
              self.errors = err.data.errors;
            });
        };
      },
    ];
  }
})();
